// src/components/Minihome/widgets/EmoteShelf.jsx

import { Stack, Typography, Box } from "@mui/material";

export default function EmoteShelf({ item }) {
    const cfg = item?.emoteConfig || {
        header: "이모티콘",
        layoutMode: "grid",
        emotes: [],
        size: 48,
        gap: 8,
    };

    // ✅ 1. header를 별도로 추출하고, '??' 연산자를 사용합니다.
    const header = cfg.header ?? "이모티콘";

    const Wrap = ({ children }) => (
        <Box
            sx={{
                height: "100%",
                width: "100%",
                p: 2,
                boxSizing: 'border-box',
                backgroundColor: item?.isTransparent ? 'transparent' : item?.backgroundColor,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {children}
        </Box>
    );

    const isUrlLike = (s) =>
        typeof s === "string" && (/^https?:\/\//i.test(s) || s.startsWith("/"));

    return (
        <Wrap>
            {/* ✅ 2. header가 있을 때만 Typography를 렌더링하도록 수정합니다. */}
            {header && (
                <Typography variant="h6" sx={{ mb: 1.5, flexShrink: 0 }}>
                    {header}
                </Typography>
            )}

            <Box sx={{ flex: 1, overflow: "auto" }}>
                <Stack
                    direction={cfg.layoutMode === "list" ? "column" : "row"}
                    spacing={cfg.gap / 8}
                    sx={{
                        flexWrap: cfg.layoutMode === "grid" ? "wrap" : "nowrap",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    {(cfg.emotes || []).map((em, idx) =>
                        isUrlLike(em) ? (
                            <Box
                                key={`${em}-${idx}`}
                                component="img"
                                src={em}
                                alt="sticker"
                                sx={{
                                    width: cfg.size,
                                    height: cfg.size,
                                    objectFit: "contain"
                                }}
                            />
                        ) : (
                            <Box key={`${em}-${idx}`} sx={{ fontSize: cfg.size * 0.8, lineHeight: 1, userSelect: "none" }}>
                                {em}
                            </Box>
                        )
                    )}
                    {(!cfg.emotes || !cfg.emotes.length) && (
                        <Typography variant="body2" color="text.secondary">
                            표시할 이모티콘을 선택해 보세요!
                        </Typography>
                    )}
                </Stack>
            </Box>
        </Wrap>
    );
}